import React from 'react';
import { motion } from 'framer-motion';

const BoxPoints = ({ title = "Valor da taxa de serviço:", serviceFee = "R$ 0,00", color = "default" }) => {
  return (
    <motion.div 
      className={`box-points ${color}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <span>
        <h3>{title}</h3>
        <motion.p
          key={serviceFee} // Chave única para reanimar em cada mudança
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {serviceFee}
        </motion.p>
      </span>
    </motion.div>
  );
};

export default BoxPoints;
